<template>
  <div class="followContainer">
    <div class="divFollow">
      <div class="divFollowing">
        <div class="following" @click="loadFollow('following')">
          <div>Seguindo</div>
          <h3>{{ !isNaN(totalFollowing)? totalFollowing : '-' }}</h3>
        </div>
      </div>

      <div class="divFollowers">
        <div class="followers" @click="loadFollow('followers')">
          <div>Seguidores</div>
          <h3>{{ !isNaN(totalFollowers)? totalFollowers + mod : '-' }}</h3>
        </div>
      </div>
    </div>

    <md-dialog class="modalFollowing" :md-active.sync="active.following">
      <div>
        <span class="titleModal">Seguindo</span>
        <!-- <span class="md-headline">Headline</span> -->

        <md-dialog-actions id="exitModal">
          <md-button @click="active.following = false">
            <md-icon>clear</md-icon>
          </md-button>
        </md-dialog-actions>
      </div>

      <follow-list :profiles="following" @clickLink="active.following = false" :disableFollowing="ownProfile" />
    </md-dialog>

    <md-dialog class="modalFollowers" :md-active.sync="active.followers">
      <div>
        <span class="titleModal">Seguidores</span>
        <!-- <span class="md-headline">Headline</span> -->

        <md-dialog-actions id="exitModal">
          <md-button @click="active.followers = false">
            <md-icon>clear</md-icon>
          </md-button>
        </md-dialog-actions>
      </div>

      <follow-list :profiles="followers" @clickLink="active.followers = false" />
    </md-dialog>

    <follow v-if="!ownProfile" v-model="followingStatus" @changeStatus="mod += $event? 1 : -1">
      <md-button
        slot-scope="{ loading, follow }"
        @click="follow($route.params.id)"
        class="md-raised md-primary buttonAdd"
        :md-ripple="false"
        :disabled="loading || stats.followers == undefined"
      >
        {{ followingStatus? "Deixar de seguir" : "Seguir" }}
      </md-button>
    </follow>
  </div>
</template>

<script>
import follow from "@/components/shared/friends/follow";
import followList from "./followList";
import call from "@/api/calls"

export default {
  components: {
    followList,
    follow
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem('user')),
    active: {
      following: false,
      followers: false,
    },
    stats: {},
    following: null,
    followers: null,
    followingStatus: false,
    loadingFollowStatus: false,
    mod: 0,  // modificador de seguidores (pra alterar se usuario deu follow/unfollow)
    error: null
  }),
  computed: {
    totalFollowing() {
      return this.stats.following;
    },
    totalFollowers() {
      return this.stats.followers;
    },
    ownProfile() {
      return this.user && this.user.id === this.$route.params.id;
    },
  },
  watch: {
    '$route.params.id'() {
      this.loadFollowStats();
      this.loadFollowingStatus();
      this.mod = 0;
    }
  },
  mounted() {
    this.loadFollowStats();
    this.loadFollowingStatus();
  },
  methods: {
    loadFollow(follow) {
      // if (this[follow])
      //   return this[follow];

      return call.friend[follow](this.$route.params.id)
      .then(followObj => this[follow] = followObj)
      .then(() => this.active[follow] = true);
    },
    loadFollowingStatus() {
      call.friend.isFollowing(this.$route.params.id, this.user.id)
      .then(isFollowing => this.followingStatus = isFollowing);
    },
    loadFollowStats() {
      call.friend.stats(this.$route.params.id)
      .then(stats => this.stats = stats);
    }
  },
}
</script>

<style scoped>
.followContainer {
  padding-bottom: 8px;
}

.divFollow {
  position: relative;
  top: 0;
  /* left: 20%;  */
  /* width: 50%; */
  text-align: center;
}

.divFollowing {
  position: relative;
  float: left;
  width: 50%;
  height: 55px;
  margin-bottom: 12px;
  border-right: 1px solid #9a9a9a;
}

.following {
  width: max-content;
  margin: 0 auto;
  cursor: pointer;
}

.divFollowers {
  position: relative;
  float: left;
  width: 50%;
  height: 55px;
  margin-bottom: 12px;
}

.followers {
  width: max-content;
  margin: 0 auto;
  cursor: pointer;
}

.titleModal {
  position: absolute;
  text-align: center;
  font-size: 20px;
  top: 20px;
  left: 25px;
  bottom: 0px;
}

#exitModal {
  top: 0;
}

.modalFollowing {
  width: 40vw;
  -webkit-flex: 1 1;
  flex: 1 1;
  overflow-y: auto;
}

.modalFollowers {
  min-width: 40vw;
  -webkit-flex: 1 1;
  flex: 1 1;
  overflow-y: auto;
}

.buttonAdd {
  position: relative;
  display: block;
  margin: auto;
  border-radius: 50px;
}
</style>
